import { GENERATE_QUESTIONS_FROM_PAST_QUIZZES } from '../prompts/prompts';
import { QuestionObj } from '../types/quiz';
import { callAi, Message } from './aiCall';

export async function generateQuestionsHelper(messages: Message[]) {
  const response = await callAi(messages);
  const json = response.substring(
    response.indexOf('{'),
    response.lastIndexOf('}') + 1,
  );
  const jsonl = response.substring(
    response.indexOf('['),
    response.lastIndexOf(']') + 1,
  );
  try {
    return JSON.parse(json);
  } catch (e) {
    try {
      return JSON.parse(jsonl);
    } catch (e) {
      console.error('Error parsing JSON', e);
      console.error('Response:', response);
      throw e;
    }
  }
}

export function generateFromPastQuizzesPrompt(
  quizIds: string[],
  questions: QuestionObj[],
) {
  let allQuestionsString = '';
  quizIds.forEach((quizId, i) => {
    const quizQuestions = questions.filter((q) => q.quizId === quizId);
    quizQuestions.sort((a, b) => (a.number ?? 0) - (b.number ?? 0));
    allQuestionsString += `## Quiz ${i + 1}\n`;
    quizQuestions.forEach((q) => {
      allQuestionsString += `${q.number}. ${q.question} (answer: ${q.answer})\n`;
    });
  });
  return GENERATE_QUESTIONS_FROM_PAST_QUIZZES + allQuestionsString;
}
